import { AD } from '@gumtree/shared/src/model/generic.model';
import { toggleSavedAd, TOGGLE_SAVED_AD } from '@gumtree/shared/src/reducers/saved-ads';

export interface State {
    makeAnOfferEnabled: boolean;
    makeAnOfferState: null | 'REQUIRE_LOGIN' | 'COLLAPSED';
    makeOfferSuccess: null | boolean;
    savedAds: { [advertId: number]: boolean };
    sendReplyUrl: string;
    sendReportSuccess: boolean;
}

const initialState: State = {
    makeAnOfferEnabled: false,
    makeAnOfferState: null,
    makeOfferSuccess: null,
    savedAds: {},
    sendReportSuccess: false,
    sendReplyUrl: '',
};

export const UPDATE_SELLER_ACTIONS = 'UPDATE_SELLER_ACTIONS';
export const updateSellerActions: AD<typeof UPDATE_SELLER_ACTIONS, Partial<State>> =
(payload) => ({
    type: UPDATE_SELLER_ACTIONS,
    payload,
});


export const SET_SEND_REPORT_SUCCESS = 'SET_SEND_REPORT_SUCCESS';
export const setSendReportSuccess: AD<typeof SET_SEND_REPORT_SUCCESS, boolean> =
(payload) => ({
    type: SET_SEND_REPORT_SUCCESS,
    payload,
});

type Action =
  | ReturnType<typeof updateSellerActions>
  | ReturnType<typeof setSendReportSuccess>
  | ReturnType<typeof toggleSavedAd>

export default (state: State = initialState, action: Action): State => {
    switch (action.type) {
        case UPDATE_SELLER_ACTIONS: {
            return {
                ...state,
                ...action.payload,
            };
        }
        case SET_SEND_REPORT_SUCCESS: {
            return {
                ...state,
                sendReportSuccess: action.payload,
            }
        }
        case TOGGLE_SAVED_AD: {
            const { advertId } = action.payload;
            return {
                ...state,
                savedAds: {
                    ...state.savedAds,
                    [advertId]: !state.savedAds[advertId],
                },
            };
        }
        default:
            return state;
    }
};
